import { canUseDOM } from '$lib/helpers';

export const useIsSSR = () => {
    const isSSR = !canUseDOM();

    return { isSSR };
};

export default useIsSSR;
